export function parseFolderId(folderId) {
  const [orientation, category] = (folderId || '').split('_');
  return {
    orientation,
    category: category === 'all' ? null : category
  };
}